import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { Language } from '../../models/language';

@Component({
    selector: 'dmv-pub-language-select',
    templateUrl: './language-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguageSelectComponent implements OnChanges {
    @Input() public languages: Array<Language>;
    @Input() public selectedLanguage: Language;
    @Input() public route: string;

    public isHidden = true;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedLanguage']) {
            if (!this.languages || this.languages.findIndex(l => l.value === this.selectedLanguage.value) === -1) {
                throw new Error(`The list of available languages does not contain a value for: ${this.selectedLanguage.value}`);
            }
        }
    }
}
